// Shared filter for the publication list tabs (Promotions, Events). The backend
// list endpoints accept `status` (repeated) + `created_at_gte` / `created_at_lte`.
export type PublicationListFilterType = {
    statuses: Array<string>;
    createdAtGte: string | null;
    createdAtLte: string | null;
};

export const emptyPublicationListFilter: PublicationListFilterType = {
    statuses: [],
    createdAtGte: null,
    createdAtLte: null,
};
